import { IBillWithPurchStAndCustomerRelationship } from "@smartrr/shared/entities/Billing";

export const checkIfBillCanBeCanceled = (
  bills: IBillWithPurchStAndCustomerRelationship[],
  selectedResources: string[]
) => {
  return bills.findIndex(bill => selectedResources.includes(String(bill.id)) && bill.status !== "pending") == -1;
};
